const en = {
  add: 'Add',
  added: 'added',
  addedBefore: 'added before',
  AddToChatPage: 'add to chat page',
  account: 'Account',
  addGroup: 'Add Group',
  enterName: 'Enter Name',
  loadEarlier: 'load earlier',
  greet: 'Welcome',
  loginUser: 'Login User',
  languege: 'Languege',
  homePage: 'Home',
  online: 'Online',
  offline: 'Offline',
  notWorking: 'Not Working',
  persian: 'Persian',
  english: 'English',
  dark: 'Dark',
  light: 'Light',
  rose: 'Rose',
  toEdit: 'Click here to edit',
  logout: 'Logout',
  theme: 'Theme',
  contact: 'Contact',
  status: 'Status',
  setting: 'setting',
  fullName: 'FullName',
  userName: 'UserName',
  bio: 'bio',
  remove: 'Remove',
  gallery: 'From Gallery',
  takePhoto: 'Take Photo',
  message: 'Message...',
  password: 'Password',
  login: 'Login',
  forgetPassword: 'Forget Password',
  dontSendNotification: 'don`t send notification',
  notifcation: 'notification',
  deleteChat: 'delete chat',
  deleteContact: 'delete contact',
  delete: 'Delete',
  messenger: 'Messenger',
  allChat: 'All',
  private: 'Private',
  group: 'Group',
  channel: 'Channel',
  newMessage: 'New Message',
  groupName: 'Group Name...',
  newGroup: 'New Group',
  yourInformationsAreFalse: 'your informations are false!',
  reply: 'reply',
  edit: 'edit',
  forward: 'forward',
  cancel: 'Cancel',
  download: 'download',
  pin: 'pin',
  copy: 'copy',
  deviceNotFound: 'device not found',
  PermissionDenied: 'permission denied',
  notSupportFile: 'not support file',
  doYouWantToDeleteThisUser: 'do you want to delete this user?',
  TypeAMessage: 'type a message',
  update: 'بروزرسانی',
  oldPassword: 'رمزعبور قبلی',
  newPassword: 'رمزعبور جدید',
  repeatNewPassword: 'تکرار رمزعبور جدید',
  updatePassword: 'Update Password',
  ThereIsNotAnyConversation: 'There is not any conversation',
  seenBy: 'seen by ',
  member: 'member',
  forwardBy: 'Forwarded by',
  passwordweak: 'The password is weak',
  savedMessage: 'Saved Messages',
  areYouSureYouWantToDeleteThisMessage:
    'Are you sure you want to delete this message?',
  setWallpaper: 'Set Wallpaper',
  pinConversation: 'Pin Conversation',
  unpinConversation: 'Unpin Conversation',
  busy: 'busy',
  away: 'away',
  white: 'White',
  select: 'Select',
  selected: 'Selected',
  confirm: 'Confirm',
  captcha: 'Captcha',
  code: 'Code',
  recivedCode: 'Received Code ',
  back: 'Back',
  changePassword: 'Change Password',
  createChat: 'Create Chat',
};

const fa = {
  add: 'ایجاد',
  added: 'اضافه شد',
  removeMember: 'حذف عضو',
  addedBefore: 'قبلا اضافه شده',
  AddToChatPage: 'به صفحه چت اضافه شد',
  account: 'حساب',
  addGroup: 'افزودن گروه',
  addMember: 'افزودن عضو',
  delete: 'حذف',
  enterName: 'نام را وارد کنید',
  loadEarlier: 'ادامه بارگذاری',
  greet: 'خوش آمدید',
  loginUser: 'ورود کاربر',
  languege: 'زبان',
  homePage: 'خانه',
  online: 'آنلاین',
  offline: 'آفلاین',
  notWorking: 'دور از سیستم',
  persian: 'فارسی',
  english: 'انگلیسی',
  dark: 'تاریک',
  light: 'روشن',
  rose: 'رز',
  toEdit: 'برای ویرایش کلیک کنید',
  logout: 'خروج',
  theme: 'قالب',
  contact: 'مخاطبین',
  status: 'وضیعت',
  yes: 'بله',
  no: 'خیر',
  setting: 'تنظیمات',
  Uploading: 'در حال بارگذاری',
  fullName: 'نام و نام خانوادگی',
  userName: 'نام کاربری',
  bio: 'درباره من',
  remove: 'حذف',
  gallery: 'از گالری',
  takePhoto: 'گرفتن عکس',
  choosePhoto: 'انتخاب عکس',
  message: 'پیام...',
  password: 'رمزعبور',
  login: 'ورود',
  leaveTheGroup: 'رفتن از گروه',
  forgetPassword: 'فراموشی رمز عبور',
  notification: 'اعلان رخداد',
  deleteChat: 'حذف مکالمات',
  deleteContact: 'حذف مخاطب',
  groupName: 'نام گروه',
  messenger: 'پیامرسان',
  members: 'اعضا',
  allChat: 'همه',
  private: 'خصوصی',
  group: 'گروه',
  channel: 'کانال',
  channelName: 'نام کانال',
  newMessage: 'پیام جدید',
  GroupName: 'نام گروه',
  newGroup: 'گروه جدید',
  yourInformationsAreFalse: 'اطلاعات واردشده نادرست است!',
  reply: 'پاسخ',
  edit: 'ویرایش',
  forward: 'ارسال',
  cancel: 'لغو',
  download: 'دانلود',
  pin: 'سنجاق ',
  copy: 'کپی',
  deviceNotFound: 'دستگاه متصل نیست',
  PermissionDenied: 'محدودیت دسترسی',
  notSupportFile: 'فایل ساپورت نمی شود',
  doYouWantToDeleteThisUser: 'آیا میخواهید این کاربر حذف شود؟',
  TypeAMessage: 'پیام خود را تایپ کنید',
  update: 'بروزرسانی',
  oldPassword: 'رمزعبور قبلی',
  newPassword: 'رمزعبور جدید',
  repeatNewPassword: 'تکرار رمزعبور جدید',
  updatePassword: 'بروزرسانی رمزعبور',
  search: 'جستجو',
  ThereIsNotAnyConversation: 'درحال حاضر هیچ مکالمه ای وجود ندارد',
  seenBy: 'دیده شده توسط',
  member: 'نفر',
  forwardBy: 'ارسال شده از',
  passwordweak: 'پسورد ضعیف است',
  savedMessage: 'پیام های ذخیره شده',
  areYouSureYouWantToDeleteThisMessage: 'آیا میخواهید این پیام حذف شود؟',
  setWallpaper: 'انتخاب پس زمینه',
  pinConversation: 'سنجاق گفتگو',
  unpinConversation: 'لغو سنجاق',
  busy: 'مشغول',
  away: 'دور از سیستم',
  white: 'سفید',
  select: 'انتخاب',
  selected: 'انتخاب شده',
  confirm: 'تایید',
  captcha: 'کپچا',
  code: 'کد',
  recivedCode: 'دریافت کد',
  back: 'بازگشت',
  changePassword: 'تغییر پسورد',
  createChat: 'ایجاد گفتگو',
};

const translate = {
  en,
  fa,
};

export default translate;
